(() => {
  const initSliders = () => {
    const slideshows = document.querySelectorAll(
      ".custom-logo-slider__slide-container"
    );
      slideshows.forEach((slideshow) => {
      if ( window.innerWidth < 768 ) {
        new Swiper(slideshow, {
          slidesPerView: 'auto',
          loop: true,
          initialSlide: 2,
        });
      } else if (slideshow.classList.contains('swiper-initialized') ){
        slideshow.swiper.destroy();
      }
    });
  };
  initSliders();

  document.addEventListener("shopify:section:load", function () {
    initSliders();
  });

  window.addEventListener("resize", function () {
    initSliders();
  });
})();
